package pl.decks.personal.extensions

import com.varabyte.kobweb.silk.theme.colors.ColorMode
import pl.decks.personal.theme.SitePalette
import pl.decks.personal.theme.SitePalettes

internal fun ColorMode.toSitePalette(): SitePalette = when (this) {
    ColorMode.DARK -> SitePalettes.dark
    ColorMode.LIGHT -> SitePalettes.light
}
